import React from "react";
import { ButtonWrapper } from "./TotemButtonStyles";

interface Props {
  onClick: () => void;
  text: string;
  disabled?: boolean;
  negative?: boolean;
}

const TotemButton: React.FC<Props> = ({
  onClick,
  text,
  disabled,
  negative,
}) => {
  const handleClick = () => {
    if (disabled) return;

    onClick();
  };

  return (
    <ButtonWrapper
      disabled={disabled}
      negative={negative}
      onClick={handleClick}
    >
      {text}
    </ButtonWrapper>
  );
};

export default TotemButton;
